module.exports = "<div id=\"map\"></div>\n<app-legend style=\"position:absolute;top:110px;right:10px;\"></app-legend>"


//////////////////
// WEBPACK FOOTER
// /Users/sofos/projects/anadigit/kounoupia-frontend/src/app/components/map/map.component.html
// module id = ../../../../../src/app/components/map/map.component.html
// module chunks = main